/* ── Unified Carousel Navigation JS ──
   Event delegation on document — works for any number of carousels,
   including sections rendered after initial page load. */

(function () {
  function getStep(track) {
    var card = track.firstElementChild;
    if (!card) return 300;
    var style = getComputedStyle(track);
    var gap = parseInt(style.columnGap || style.gap || '0', 10);
    return card.offsetWidth + gap;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev]');
    if (btn) {
      var track = document.getElementById(btn.getAttribute('data-carousel-track'));
      if (track) track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
      return;
    }
    btn = e.target.closest('[data-carousel-next]');
    if (btn) {
      var track = document.getElementById(btn.getAttribute('data-carousel-track'));
      if (track) track.scrollBy({ left: getStep(track), behavior: 'smooth' });
    }
  });
})();
